import * as itemTypes from './itemTypes'
import simpleScaleItem from '@/components/items/simpleScaleItem'
import singleChoiceItem from '@/components/items/singleChoiceItem'
import sliderItem from '@/components/items/sliderItem'
import bellCurveItem from '@/components/items/bellCurveItem'
import textItem from '@/components/items/textItem'
import numInputItem from '@/components/items/numInputItem'
import gainsLossesItem from '@/components/items/gainsLossesItem'
import ipsativeChoiceItem from '@/components/items/ipsativeChoiceItem'
import rankedOrderItem from '@/components/items/rankedOrderItem'
import multiChoiceItem from '@/components/items/multiChoiceItem'
import multiChoiceOtherItem from '@/components/items/multiChoiceOtherItem'
import sliderChoiceItem from '@/components/items/sliderChoiceItem'
import dropdownChoiceItem from '@/components/items/dropdownChoiceItem'
import OutcomeTaskContainer from '@/containers/Items/OutcomeTaskContainer'
import textInputItem from '@/components/items/textInputItem'
import textInputGdprItem from '@/components/items/textInputGdprItem'
import intermediateResultItem from '@/components/items/intermediateResultItem'
import matrixChoiceItem from '@/components/items/matrixChoiceItem'
import matrixChoiceOtherItem from '@/components/items/matrixChoiceOtherItem'
import InteractionChoiceContainer from '@/containers/Items/InteractionChoiceContainer'
import discreteSliderManyItem from '@/components/items/discreteSliderManyItem'
import dropdownTextCountryItem from '@/components/items/dropdownTextCountryItem'
import dropdownTextYearItem from '@/components/items/dropdownTextYearItem'
import emailCheckboxItem from '@/components/items/emailCheckboxItem'

export const ITEMS = {
    [itemTypes.BUTTON]: simpleScaleItem,
    [itemTypes.SINGLE_CHOICE]: singleChoiceItem,
    [itemTypes.SLIDER]: sliderItem,
    [itemTypes.SLIDER_IMG]: bellCurveItem,
    [itemTypes.TEXT]: textItem,
    [itemTypes.GAINS_AND_LOSSES]: gainsLossesItem,
    [itemTypes.INPUT_NUM]: numInputItem,
    [itemTypes.STACK_SORT]: rankedOrderItem,
    [itemTypes.I_CHOICE]: ipsativeChoiceItem,
    [itemTypes.ORDER_CHOICE]: rankedOrderItem,
    [itemTypes.MULTI_CHOICE]: multiChoiceItem,
    [itemTypes.MULTI_CHOICE_OTHER]: multiChoiceOtherItem,
    [itemTypes.SLIDER_CHOICE]: sliderChoiceItem,
    [itemTypes.DROPDOWN_CHOICE]: dropdownChoiceItem,
    [itemTypes.OUTCOME_TASK]: OutcomeTaskContainer,
    [itemTypes.TEXT_INPUT]: textInputItem,
    [itemTypes.TEXT_INPUT_GDPR]: textInputGdprItem,
    [itemTypes.INTERMEDIATE_RESULT]: intermediateResultItem,
    [itemTypes.INTERACTION_CHOICE]: InteractionChoiceContainer,
    [itemTypes.MULTI_CHOICE_RADIO_OTHER]: multiChoiceOtherItem,
    [itemTypes.MATRIX_CHOICE]: matrixChoiceItem,
    [itemTypes.MATRIX_CHOICE_OTHER]: matrixChoiceOtherItem,
    [itemTypes.DISCRETE_SLIDER_MANY]: discreteSliderManyItem,
    [itemTypes.DROPDOWN_TEXT_COUNTRY]: dropdownTextCountryItem,
    [itemTypes.DROPDOWN_TEXT_YEAR]: dropdownTextYearItem,
    [itemTypes.EMAIL_CHECKBOX]: emailCheckboxItem
}

export const CHOICE_RESULTS = {
  TRUE: 1,
  NONE: 0,
  HIGHEST: 2,
  LOWEST: 1,
}

export const IPSATIVE_RESULTS = {
    LOWEST: 0,
    HIGHEST: 2,
    NEUTRAL: 1,
}

export const OUTCOME_TASK_RESULTS = {
    RISK: 'R',
    SAFE: 'S',
}


/* ITEM PROPS */
export const STYLE_ITEM = 'style'
export const DONE_ITEM = 'done'
export const INTER_ITEM = 'inter'
export const META_ITEM = 'metadata'
export const HIDDEN_ITEM = 'hidden'
export const COLOR_VARIANT = 'color_variant'
export const SORT_ORDER = 'sort_order'
export const ITEM_MODE = 'item_mode'
export const ICON = 'icon'
export const SHOW_MIDMARKER = 'show_midmarker'
export const SHOW_RANGE = 'show_range'
export const SHOW_TOOLTIP = 'show_tooltip'
export const SLIDER_START = 'slider_start'
export const STACK_CONFIG = 'stack_config'
export const IAT_TASK_NAME = 'iat_task_name'
export const PROGRESS_HIDDEN = 'progress_hidden'
export const LOGO_HIDDEN = 'logo_hidden'
export const LOGO_IN_ICON = 'logo_in_icon'
